/**
 * @generated SignedSource<<5045843f214534c67048023b5e27943d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NotificationNotificationType = "CONDITIONSACCEPTED" | "CONFIRMACCOUNT" | "DEPRECATED" | "DEPRECATED_80" | "EDITMODEREMINDER" | "EVALUATIONREMINDER" | "EVALUATIONSESSIONREMINDER" | "EVALUATIONSESSIONSTART" | "EXPIRATIONREMINDERTOUNANSWEREDREFERENCEVALIDATION" | "INVITETOCONCEPTEVALUATION" | "INVITETOPITCHEVALUATION" | "INVITETOREFERENCEVALIDATION" | "INVITETORFQ" | "NEWANNOUNCEMENT" | "NEWANSWERSTOQUESTIONS" | "NEWCLIENTCALLBACKWASPOSTED" | "NEWORGANIZATIONACCOUNT" | "NEWPROJECTCREATEDRFP" | "NEWPROJECTCREATEDRFQ" | "NEWPROJECTREQUEST" | "NEWPROJECTSTATUS" | "NEWPROJECTSTATUSRFQ" | "NEWPROJECTSUBMITTEDRFP" | "NEWPROJECTSUBMITTEDRFQ" | "NEWPROPOSALSUBMITTEDRFP" | "NEWPROPOSALSUBMITTEDRFQ" | "NEWQUESTIONS" | "NEWRATESSUBMITTED" | "NEWSUPPORTQUESTION" | "NEWUSERACCOUNTACTIVATED" | "NEWUSERACCOUNTCREATED" | "OVERDUEPROJECTS" | "PARTICIPATIONCANCELLEDBYVENDOR" | "PITCHEVALUATIONREMINDER" | "PITCHINVITATION" | "PITCHINVITATIONACCEPTED" | "PITCHINVITATIONDECLINED" | "PROJECTAWARDINGDUE" | "PROJECTAWARDINGDUEDATEREMINDER" | "PROJECTINVITATIONACCEPTEDRFQ" | "PROJECTREQUESTREJECTED" | "PROPOSALACCEPTED" | "PROPOSALAWARDINGCLIENTINTERNAL" | "PROPOSALAWARDINGDUE" | "PROPOSALAWARDINGDUEDATEREMINDER" | "PROPOSALAWARDINGTOSUPPLIER" | "PROPOSALCANCELLATIONBYSUPPLIER" | "PROPOSALDELETED" | "PROPOSALDISMISSED" | "PROPOSALDUEDATEREMINDER" | "PROPOSALINVITATION" | "PROPOSALLOSTMESSAGETOSUPPLIER" | "PROPOSALPARTICIPATIONCONFIRMATION" | "PROPOSALREVISIONREQUESTED" | "RATEREVISIONREQUESTED" | "RATESCONFIRMED" | "RATESREJECTED" | "RECOVERPASSWORD" | "REFERENCECANCELLED" | "REFERENCECONFIRMED" | "REFERENCEEXPIRED" | "REFERENCEPIN" | "REFERENCEREJECTED" | "REMINDERFORCONFIRMATIONOFRFQ" | "REMINDERFORCONFIRMATIONOFRRFP" | "REMINDERFORINVITETORFP" | "REMINDERFORINVITETORFQ" | "REMINDERFORPROPOSALDUEDATE" | "REMINDERTOUNANSWEREDQUESTIONS" | "REMINDERTOUNANSWEREDREFERENCEVALIDATION" | "REQUESTNEWPROPOSAL" | "SECONDREMINDERTOUNANSWEREDREFERENCEVALIDATION" | "SUCCESSFULPROPOSALSUBMISSION" | "SUCCESSFULRATECARDPROPOSALSUBMISSION" | "SUPPLIERCONFIRMSTNCS" | "SUPPLIERDISMISSEDFROMRFP" | "SUPPLIERREJECTSTNCS" | "SURVEYINVITE" | "TIMELINECHANGE" | "USERASSIGNEDTORFP" | "USERASSIGNEDTORFQ" | "%future added value";
export type MarkNotificationAsReadInput = {
  clientMutationId?: string | null;
  notificationId: string;
};
export type NotificationElementMarkAsReadMutation$variables = {
  input: MarkNotificationAsReadInput;
};
export type NotificationElementMarkAsReadMutation$data = {
  readonly markNotificationAsRead: {
    readonly notification: {
      readonly context: any | null;
      readonly created: any;
      readonly id: string;
      readonly notificationType: NotificationNotificationType;
      readonly unread: boolean;
    } | null;
  } | null;
};
export type NotificationElementMarkAsReadMutation = {
  response: NotificationElementMarkAsReadMutation$data;
  variables: NotificationElementMarkAsReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkNotificationAsReadPayload",
    "kind": "LinkedField",
    "name": "markNotificationAsRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationNode",
        "kind": "LinkedField",
        "name": "notification",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notificationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unread",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "context",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationElementMarkAsReadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationElementMarkAsReadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7888e81a1027fe766fd4d1a1d03674e0",
    "id": null,
    "metadata": {},
    "name": "NotificationElementMarkAsReadMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationElementMarkAsReadMutation(\n  $input: MarkNotificationAsReadInput!\n) {\n  markNotificationAsRead(input: $input) {\n    notification {\n      id\n      notificationType\n      created\n      unread\n      context\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1355c82b5ab6d3beddb13f9619b07d31";

export default node;
